import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/hooks/useDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';
import NewFixedFeesContent from './NewFixedFeesContent';

const INIT_FILTER = {
  q: '',
  sort_by: 'desc',
  // tax_revenue_type_id: 4,
};

function NewFixedFeesContainer({
  match,
  history,
  getNewFixedFeesList,
  newFixedFeesList,
  isLoading,
  removeNewFixedFees,
  newFixedFeesListPager,
  getSingleNewFixedFees,
  ordinanceRevisionId,
}) {
  const [filter, setFilter] = useState(INIT_FILTER);
  const debouncedFilter = useDebounce(filter, 500);
  const setModal = useContext(ModalContext);

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal ordinanceRevisionId={ordinanceRevisionId} />,
      title: 'Add Fixed Fee',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          ordinanceRevisionId={ordinanceRevisionId}
          updateList={data.attributes}
          id={data.id}
        />
      ),
      title: 'Update Fixed Fee',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this fixed fee?',
      () => {
        removeNewFixedFees(data.id, () => {
          setFilter((prev) => ({
            ...prev,
            q: '',
          }));
          const id = _.get(newFixedFeesList, '1.id');
          history.push(`/bpls/tax-revenue/new-fixed-fees/${id}`);
          getSingleNewFixedFees(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    if (debouncedFilter?.ordinance_revision_id) {
      getNewFixedFeesList(debouncedFilter);
    }
  }, [JSON.stringify(debouncedFilter)]);

  useEffect(() => {
    if (ordinanceRevisionId) {
      setFilter((prev) => ({
        ...prev,
        ordinance_revision_id: ordinanceRevisionId,
      }));
    }
  }, [ordinanceRevisionId]);

  const handleOnChange = (key, value) => {
    setFilter((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <Route
      path={`${match.path}/:newFixedFeesId?`}
      render={({ match: { params } }) => (
        <GenericListPair
          moduleName="Fixed Fees"
          // getData={getNewFixedFeesList}
          // setParams={param}
          setKeyword={(e) =>
            handleOnChange(
              e?.target.name,
              e?.target.value
              // e?.target.value.length
            )
          }
          keyword={_.get(filter, 'q') || ''}
          keywordPlaceholder="Search..."
          listName="newFixedFees"
          label="Fixed Fees"
          renderItem={(item) => (
            <div className="px-3 py-3">
              {_.get(item, 'attributes.name')}
              <h4 className="mt-1 mb-0 transaction-list-name">
                {_.get(item, 'attributes.description')}
              </h4>
            </div>
          )}
          isLoading={isLoading}
          selected={params.newFixedFeesId}
          data={newFixedFeesList}
          dataPager={newFixedFeesListPager}
          handleSelectRow={(data) => {
            history.push(`${match.url}/${_.get(data, 'id')}`);
          }}
          renderContent={() => (
            <React.Fragment>
              <Switch>
                <Route
                  path={`${match.path}/:newFixedFeesId?`}
                  render={() => (
                    <NewFixedFeesContent
                      ordinanceRevisionId={ordinanceRevisionId}
                      handleAddModal={handleAddModal}
                      handleEdit={handleEdit}
                      handleRemove={handleRemove}
                    />
                  )}
                />
              </Switch>
              <Route
                path={`${match.path}/:newFixedFeesId?`}
                render={() =>
                  !params.id && newFixedFeesList.length > 0 ? (
                    <Redirect
                      to={`${match.url}/${_.get(newFixedFeesList, '0.id')}`}
                    />
                  ) : null
                }
              />
            </React.Fragment>
          )}
          handleChangePage={(page) => setFilter((prev) => ({ ...prev, page }))}
        />
      )}
    />
  );
}

NewFixedFeesContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getNewFixedFeesList: PropTypes.instanceOf(Function).isRequired,
  newFixedFeesList: PropTypes.instanceOf(Array).isRequired,
  newFixedFeesListPager: PropTypes.instanceOf(Object).isRequired,
  removeNewFixedFees: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getSingleNewFixedFees: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  newFixedFeesList: _.get(api, `${c.GET_NEW_FIXED_FEES}.list`) || [],
  newFixedFeesListPager: _.get(api, `${c.GET_NEW_FIXED_FEES}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_NEW_FIXED_FEES) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(NewFixedFeesContainer);
